/** @jsx jsx */
import { css, jsx, keyframes } from '@emotion/react';

import * as React from 'react';

const wave = keyframes`
  0% {
    height: 6px;
    opacity: 1;
  }

  50% {
    height: 16px;
    opacity: 0.2;
  }

  100% {
    height: 6px;
    opacity: 1;
  }
`;

const styles = {
  root: css`
    display: inline;
    margin-left: var(--cds-spacing-100);
  `,
  line: css`
    display: inline-block;
    vertical-align: middle;
    margin-right: 2px;
    width: 4px;
    height: 6px;
    background-color: var(--cds-color-blue-500);
    animation: ${wave} 1s infinite;
    border-radius: var(--cds-spacing-50);
  `,
  line2: css`
    animation-delay: 0.25s;
  `,
  line3: css`
    animation-delay: 0.5s;
  `,
};

const AIIndicator = (): React.ReactElement => {
  return (
    <span contentEditable={false} css={styles.root}>
      <span css={styles.line} />
      <span css={[styles.line, styles.line2]} />
      <span css={[styles.line, styles.line3]} />
    </span>
  );
};

export default AIIndicator;
